import { useLayoutEffect } from 'react'

const claims = new Set<symbol>()

/**
 * Prevents the body from scrolling when the `prevent` prop is true
 * @param {boolean} prevent - Whether to prevent the body from scrolling
 */
export function usePreventScroll({ prevent }: { prevent: boolean }) {
  useLayoutEffect(() => {
    if (prevent) {
      const claim = Symbol()
      claims.add(claim)

      if (claims.size === 1) {
        const hasScrollbar = window.innerWidth !== document.documentElement.clientWidth

        document.body.style.top = `-${window.scrollY}px`
        document.body.style.left = '0'
        document.body.style.right = '0'
        document.body.style.position = 'fixed'

        if (hasScrollbar) {
          document.documentElement.style.overflowY = 'scroll'
        }
      }

      return () => {
        claims.delete(claim)

        if (claims.size === 0) {
          const scrollY = document.body.style.top
          document.body.style.top = ''
          document.body.style.left = ''
          document.body.style.right = ''
          document.body.style.position = ''
          document.documentElement.style.overflowY = ''
          window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
      }
    }
    return
  }, [prevent])
}
